import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../services/firebaseConnection";
import { collection, getDocs, orderBy, query } from "firebase/firestore";

import "./nuvem.css";
import home from "../../assets/icons/bookfuncionario/turn.png";

const estadoColaboradorInicial = {
  id: "",
  nome: "",
  obra: "",
  cpf: "",
  funcao: "",
  situacao: "",
};

const Nuvem = () => {
  const navigate = useNavigate();

  const [busca, setBusca] = useState("");
  const [colaborador, setColaborador] = useState(estadoColaboradorInicial);
  const [colaboradores, setColaboradores] = useState([]);
  const [sugestoes, setSugestoes] = useState([]);
  const [mostrarSugestoes, setMostrarSugestoes] = useState(false);

  const [gruposTreinamentos, setGruposTreinamentos] = useState([]);
  const [mostrarArquivos, setMostrarArquivos] = useState(false);
  const [loadingColaboradores, setLoadingColaboradores] = useState(false);
  const [loadingTreinamentos, setLoadingTreinamentos] = useState(false);
  const [pdfOverlay, setPdfOverlay] = useState(null);

  const [filtroDocumentos, setFiltroDocumentos] = useState("");
  const [filtroVisualizacao, setFiltroVisualizacao] = useState("TODOS");

  const sugestoesRef = useRef(null);

  const normalizarTexto = (texto = "") =>
    String(texto || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toUpperCase()
      .trim()
      .replace(/\s+/g, " ");

  const limparCPF = (cpf = "") => String(cpf || "").replace(/\D/g, "");

  const formatarCPF = (cpf = "") => {
    const numeros = limparCPF(cpf);
    if (numeros.length !== 11) return cpf || "";
    return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  };

  const obterValorData = (data) => {
    if (!data) return 0;

    if (typeof data?.toDate === "function") {
      return data.toDate().getTime();
    }

    if (typeof data === "string" && /^\d{4}-\d{2}-\d{2}$/.test(data)) {
      const [ano, mes, dia] = data.split("-");
      return new Date(Number(ano), Number(mes) - 1, Number(dia)).getTime();
    }

    const dataObj = new Date(data);
    return Number.isNaN(dataObj.getTime()) ? 0 : dataObj.getTime();
  };

  const formatarDataBR = (data) => {
    if (!data) return "DATA NÃO INFORMADA";

    if (typeof data === "string" && /^\d{4}-\d{2}-\d{2}$/.test(data)) {
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    }

    const dataObj =
      typeof data?.toDate === "function" ? data.toDate() : new Date(data);

    if (Number.isNaN(dataObj.getTime())) {
      return "DATA NÃO INFORMADA";
    }

    return dataObj.toLocaleDateString("pt-BR");
  };

  const obterDataReferencia = (treinamento) =>
    treinamento.dataCadastro ||
    treinamento.dataLancamento ||
    treinamento.criadoEm ||
    treinamento.data ||
    "";

  const obterNomeTreinamento = (treinamento) =>
    normalizarTexto(treinamento.treinamentoNome || treinamento.tipo || "");

  const obterContextoTreinamento = (treinamento) => {
    const obraAtual = normalizarTexto(colaborador.obra || "OBRA NÃO INFORMADA");
    const funcaoAtual = normalizarTexto(
      colaborador.funcao || "FUNÇÃO NÃO INFORMADA",
    );

    const obraNaData = normalizarTexto(
      treinamento.obraNaData ||
        treinamento.obraLancamento ||
        treinamento.obraDoLancamento ||
        treinamento.obra ||
        "",
    );

    const funcaoNaData = normalizarTexto(
      treinamento.funcaoNaData ||
        treinamento.funcaoLancamento ||
        treinamento.funcaoDoLancamento ||
        treinamento.funcao ||
        "",
    );

    const possuiContextoSalvo = Boolean(obraNaData || funcaoNaData);
    const obra = obraNaData || obraAtual;
    const funcao = funcaoNaData || funcaoAtual;
    const contextoAtual = obra === obraAtual && funcao === funcaoAtual;

    return {
      obra,
      funcao,
      obraAtual,
      funcaoAtual,
      contextoAtual,
      possuiContextoSalvo,
      avisoContexto: possuiContextoSalvo
        ? ""
        : "ESTE LANÇAMENTO É ANTIGO E NÃO POSSUI OBRA/FUNÇÃO SALVAS NA DATA. O SISTEMA ESTÁ USANDO O CONTEXTO ATUAL COMO REFERÊNCIA.",
    };
  };

  useEffect(() => {
    const buscarColaboradores = async () => {
      try {
        setLoadingColaboradores(true);

        const funcionariosQuery = query(
          collection(db, "funcionarios"),
          orderBy("nome"),
        );

        const snapshot = await getDocs(funcionariosQuery);

        const lista = snapshot.docs
          .map((docItem) => {
            const dados = docItem.data();

            return {
              id: docItem.id,
              ...dados,
              nome: normalizarTexto(dados.nome || ""),
              obra: normalizarTexto(dados.obra || ""),
              funcao: normalizarTexto(dados.funcao || ""),
              situacao: normalizarTexto(dados.situacao || "ATIVO"),
              nomeBusca: normalizarTexto(dados.nome || ""),
              cpfLimpo: limparCPF(dados.cpf || docItem.id || ""),
            };
          })
          .filter((item) => item.nome);

        setColaboradores(lista);
      } catch (error) {
        console.error("Erro ao buscar colaboradores:", error);
      } finally {
        setLoadingColaboradores(false);
      }
    };

    buscarColaboradores();
  }, []);

  useEffect(() => {
    const fecharAoClicarFora = (event) => {
      if (
        sugestoesRef.current &&
        !sugestoesRef.current.contains(event.target)
      ) {
        setMostrarSugestoes(false);
      }
    };

    document.addEventListener("mousedown", fecharAoClicarFora);

    return () => {
      document.removeEventListener("mousedown", fecharAoClicarFora);
    };
  }, []);

  useEffect(() => {
    if (!pdfOverlay) return;

    const fecharComEsc = (event) => {
      if (event.key === "Escape") {
        setPdfOverlay(null);
      }
    };

    document.addEventListener("keydown", fecharComEsc);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", fecharComEsc);
      document.body.style.overflow = "auto";
    };
  }, [pdfOverlay]);

  const pesquisarColaborador = (valor) => {
    const texto = normalizarTexto(valor);
    setBusca(texto);

    if (!texto) {
      setSugestoes([]);
      setMostrarSugestoes(false);
      setColaborador(estadoColaboradorInicial);
      setGruposTreinamentos([]);
      setMostrarArquivos(false);
      setFiltroDocumentos("");
      setFiltroVisualizacao("TODOS");
      return;
    }

    const cpfDigitado = limparCPF(texto);

    const resultados = colaboradores.filter((item) => {
      const bateNome = item.nomeBusca.includes(texto);
      const bateCPF =
        cpfDigitado.length > 0 && item.cpfLimpo.includes(cpfDigitado);
      return bateNome || bateCPF;
    });

    setSugestoes(resultados.slice(0, 10));
    setMostrarSugestoes(resultados.length > 0);
  };

  const selecionarColaborador = (item) => {
    setBusca(item.nome || "");

    setColaborador({
      id: item.id,
      nome: item.nome || "",
      obra: item.obra || "",
      cpf: item.cpf || item.id || "",
      funcao: item.funcao || "",
      situacao: item.situacao || "ATIVO",
    });

    setSugestoes([]);
    setMostrarSugestoes(false);
    setGruposTreinamentos([]);
    setMostrarArquivos(false);
    setFiltroDocumentos("");
    setFiltroVisualizacao("TODOS");
  };

  const marcarTreinamentosAtuais = (lista) => {
    const mapaMaisRecentes = new Map();

    lista.forEach((treinamento) => {
      const nome = obterNomeTreinamento(treinamento);
      if (!nome) return;

      const dataTreinamento = obterValorData(treinamento.data);
      const dataReferencia = obterValorData(obterDataReferencia(treinamento));
      const dataComparacao = dataTreinamento || dataReferencia;

      const existente = mapaMaisRecentes.get(nome);

      if (!existente || dataComparacao > existente.dataComparacao) {
        mapaMaisRecentes.set(nome, {
          id: treinamento.id,
          dataComparacao,
        });
      }
    });

    return lista.map((treinamento) => {
      const nome = obterNomeTreinamento(treinamento);
      const maisRecente = mapaMaisRecentes.get(nome);

      return {
        ...treinamento,
        treinamentoAtual: maisRecente?.id === treinamento.id,
      };
    });
  };

  const montarGruposHistoricos = (lista) => {
    const listaComAtual = marcarTreinamentosAtuais(lista);

    const treinamentosComContexto = listaComAtual.map((treinamento) => {
      const contexto = obterContextoTreinamento(treinamento);

      return {
        ...treinamento,
        contexto,
        dataReferencia: obterDataReferencia(treinamento),
      };
    });

    const gruposMap = new Map();

    treinamentosComContexto.forEach((treinamento) => {
      const chave = `${treinamento.contexto.obra}__${treinamento.contexto.funcao}`;

      if (!gruposMap.has(chave)) {
        gruposMap.set(chave, {
          chave,
          obra: treinamento.contexto.obra,
          funcao: treinamento.contexto.funcao,
          contextoAtual: treinamento.contexto.contextoAtual,
          possuiContextoSalvo: treinamento.contexto.possuiContextoSalvo,
          avisoContexto: treinamento.contexto.avisoContexto,
          dataInicio: treinamento.dataReferencia || "",
          dataFim: treinamento.dataReferencia || "",
          treinamentos: [],
        });
      }

      const grupo = gruposMap.get(chave);
      grupo.treinamentos.push(treinamento);

      const dataTreinamento = obterValorData(treinamento.dataReferencia);
      const dataInicioAtual = obterValorData(grupo.dataInicio);
      const dataFimAtual = obterValorData(grupo.dataFim);

      if (
        !grupo.dataInicio ||
        (dataTreinamento && dataTreinamento < dataInicioAtual)
      ) {
        grupo.dataInicio = treinamento.dataReferencia;
      }

      if (
        !grupo.dataFim ||
        (dataTreinamento && dataTreinamento > dataFimAtual)
      ) {
        grupo.dataFim = treinamento.dataReferencia;
      }
    });

    return Array.from(gruposMap.values()).sort((a, b) => {
      if (a.contextoAtual && !b.contextoAtual) return -1;
      if (!a.contextoAtual && b.contextoAtual) return 1;

      const dataA = obterValorData(a.dataFim);
      const dataB = obterValorData(b.dataFim);
      return dataB - dataA;
    });
  };

  const montarTextoPesquisaTreinamento = (treinamento, grupo) => {
    const campos = [
      treinamento.treinamentoNome,
      treinamento.tipo,
      treinamento.anexoNome,
      treinamento.avaliador,
      treinamento.cadastradoPor,
      treinamento.atualizadoPor,
      treinamento.tipoLancamento,
      treinamento.treinamentoAtual
        ? "TREINAMENTO ATUAL ATUAL VALIDO"
        : "HISTORICO ANTIGO SUBSTITUIDO VELHO",
      treinamento.data,
      treinamento.dataReferencia,
      formatarDataBR(treinamento.data),
      formatarDataBR(treinamento.dataReferencia),
      grupo.obra,
      grupo.funcao,
      grupo.contextoAtual ? "CONTEXTO ATUAL" : "HISTORICO ANTERIOR",
      `OBRA ${grupo.obra}`,
      `FUNCAO ${grupo.funcao}`,
      `CARGO ${grupo.funcao}`,
      `PERIODO ${formatarDataBR(grupo.dataInicio)} ATE ${formatarDataBR(grupo.dataFim)}`,
    ];

    return normalizarTexto(campos.filter(Boolean).join(" "));
  };

  const gruposFiltrados = (() => {
    const termo = normalizarTexto(filtroDocumentos);

    return gruposTreinamentos
      .map((grupo) => {
        let treinamentos = [...grupo.treinamentos];

        if (termo) {
          treinamentos = treinamentos.filter((treinamento) =>
            montarTextoPesquisaTreinamento(treinamento, grupo).includes(termo),
          );
        }

        if (filtroVisualizacao === "ATUAIS") {
          treinamentos = treinamentos.filter(
            (treinamento) => treinamento.treinamentoAtual,
          );
        }

        if (filtroVisualizacao === "HISTORICO") {
          treinamentos = treinamentos.filter(
            (treinamento) => !treinamento.treinamentoAtual,
          );
        }

        return {
          ...grupo,
          treinamentos,
        };
      })
      .filter((grupo) => grupo.treinamentos.length > 0);
  })();

  const totalTreinamentos = gruposTreinamentos.reduce(
    (total, grupo) => total + grupo.treinamentos.length,
    0,
  );

  const totalTreinamentosAtuais = gruposTreinamentos.reduce(
    (total, grupo) =>
      total +
      grupo.treinamentos.filter((treinamento) => treinamento.treinamentoAtual)
        .length,
    0,
  );

  const totalTreinamentosHistorico =
    totalTreinamentos - totalTreinamentosAtuais;

  const totalTreinamentosVisiveis = gruposFiltrados.reduce(
    (total, grupo) => total + grupo.treinamentos.length,
    0,
  );

  const buscarTreinamentos = async () => {
    if (!colaborador.id) {
      alert("SELECIONE UM COLABORADOR ANTES DE ACESSAR A PASTA.");
      return;
    }

    try {
      setLoadingTreinamentos(true);
      setMostrarArquivos(true);
      setFiltroDocumentos("");
      setFiltroVisualizacao("TODOS");

      const treinamentosRef = collection(
        db,
        "funcionarios",
        colaborador.id,
        "treinamentos",
      );

      const snapshot = await getDocs(treinamentosRef);

      const lista = snapshot.docs.map((docItem) => ({
        id: docItem.id,
        ...docItem.data(),
      }));

      const grupos = montarGruposHistoricos(lista);
      setGruposTreinamentos(grupos);
    } catch (error) {
      console.error("Erro ao buscar treinamentos:", error);
      alert("ERRO AO BUSCAR TREINAMENTOS DO COLABORADOR.");
    } finally {
      setLoadingTreinamentos(false);
    }
  };

  const abrirPdfOverlay = (treinamento) => {
    if (!treinamento.anexoUrl) {
      alert("ESTE TREINAMENTO NÃO POSSUI PDF ANEXADO.");
      return;
    }

    setPdfOverlay({
      nome: treinamento.treinamentoNome || treinamento.tipo || "DOCUMENTO",
      url: treinamento.anexoUrl,
      obra: treinamento.contexto?.obra || "",
      funcao: treinamento.contexto?.funcao || "",
      data: treinamento.data || "",
      treinamentoAtual: treinamento.treinamentoAtual,
    });
  };

  const abrirNovaAba = (url) => {
    if (!url) {
      alert("ESTE TREINAMENTO NÃO POSSUI PDF ANEXADO.");
      return;
    }

    window.open(url, "_blank", "noopener,noreferrer");
  };

  const voltar = () => {
    navigate("/main");
  };

  return (
    <div className="container-nuvem">
      <div className="nuvem-content">
        <div className="box-busca" ref={sugestoesRef}>
          <input
            type="text"
            placeholder={
              loadingColaboradores
                ? "CARREGANDO COLABORADORES..."
                : "DIGITE O NOME OU CPF DO COLABORADOR"
            }
            value={busca}
            onChange={(e) => pesquisarColaborador(e.target.value)}
            disabled={loadingColaboradores}
          />

          {mostrarSugestoes && (
            <div className="dropdown-nuvem">
              {sugestoes.map((item) => (
                <div
                  key={item.id}
                  className="dropdown-nuvem-item"
                  onClick={() => selecionarColaborador(item)}
                >
                  <strong>{item.nome}</strong>
                  <span>
                    {formatarCPF(item.cpf || item.id)} ·{" "}
                    {item.funcao || "FUNÇÃO NÃO INFORMADA"} ·{" "}
                    {item.obra || "OBRA NÃO INFORMADA"}
                  </span>
                  <small
                    className={
                      item.situacao === "ATIVO"
                        ? "situacao-ativo"
                        : "situacao-desativado"
                    }
                  >
                    {item.situacao === "ATIVO" ? "ATIVO" : "DESATIVADO"}
                  </small>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="box-dados">
          <div className="linha">
            <input
              placeholder="NOME DO COLABORADOR"
              value={colaborador.nome}
              readOnly
            />
            <input placeholder="OBRA ATUAL" value={colaborador.obra} readOnly />
          </div>

          <div className="linha">
            <input
              placeholder="CPF"
              value={formatarCPF(colaborador.cpf)}
              readOnly
            />
            <input
              placeholder="FUNÇÃO ATUAL"
              value={colaborador.funcao}
              readOnly
            />
          </div>

          {colaborador.id && (
            <div className="linha-contexto-atual">
              <span
                className={
                  colaborador.situacao === "ATIVO"
                    ? "tag-situacao ativo"
                    : "tag-situacao desativado"
                }
              >
                {colaborador.situacao || "SITUAÇÃO NÃO INFORMADA"}
              </span>
              <p>
                A NUVEM MOSTRA OS DOCUMENTOS PELO CONTEXTO EM QUE FORAM
                LANÇADOS, DESTACANDO QUAL É O TREINAMENTO ATUAL E QUAIS FICARAM
                COMO HISTÓRICO.
              </p>
            </div>
          )}
        </div>

        {!mostrarArquivos && (
          <div className="box-acesso" onClick={buscarTreinamentos}>
            <h2>ACESSE A PASTA DO COLABORADOR</h2>
          </div>
        )}

        {mostrarArquivos && (
          <div className="box-all">
            <div className="barra-filtro-nuvem">
              <input
                type="text"
                placeholder="PESQUISAR POR TREINAMENTO, OBRA, CARGO OU PERÍODO"
                value={filtroDocumentos}
                onChange={(e) =>
                  setFiltroDocumentos(e.target.value.toLocaleUpperCase())
                }
              />

              <span>
                {totalTreinamentosVisiveis} DE {totalTreinamentos} REGISTROS
              </span>
            </div>

            <div className="barra-tipo-visualizacao">
              <button
                type="button"
                className={filtroVisualizacao === "TODOS" ? "ativo" : ""}
                onClick={() => setFiltroVisualizacao("TODOS")}
              >
                TODOS
                <strong>{totalTreinamentos}</strong>
              </button>

              <button
                type="button"
                className={filtroVisualizacao === "ATUAIS" ? "ativo" : ""}
                onClick={() => setFiltroVisualizacao("ATUAIS")}
              >
                TREINAMENTOS ATUAIS
                <strong>{totalTreinamentosAtuais}</strong>
              </button>

              <button
                type="button"
                className={filtroVisualizacao === "HISTORICO" ? "ativo" : ""}
                onClick={() => setFiltroVisualizacao("HISTORICO")}
              >
                HISTÓRICO
                <strong>{totalTreinamentosHistorico}</strong>
              </button>
            </div>

            <div
              className={`box-arquivos ${
                totalTreinamentosVisiveis > 7 ? "com-scroll" : ""
              }`}
            >
              {loadingTreinamentos ? (
                <div className="mensagem-nuvem">CARREGANDO TREINAMENTOS...</div>
              ) : gruposFiltrados.length > 0 ? (
                gruposFiltrados.map((grupo) => (
                  <div className="grupo-historico-nuvem" key={grupo.chave}>
                    <div
                      className={
                        grupo.contextoAtual
                          ? "cabecalho-historico-nuvem atual"
                          : "cabecalho-historico-nuvem anterior"
                      }
                    >
                      <div>
                        <strong>
                          {grupo.contextoAtual
                            ? "CONTEXTO ATUAL DO COLABORADOR"
                            : "HISTÓRICO DE OBRA / FUNÇÃO ANTERIOR"}
                        </strong>

                        <span>
                          LANÇADO QUANDO ESTAVA EM: OBRA {grupo.obra} · FUNÇÃO{" "}
                          {grupo.funcao}
                        </span>

                        {!grupo.possuiContextoSalvo && grupo.avisoContexto && (
                          <em>{grupo.avisoContexto}</em>
                        )}
                      </div>

                      <small>
                        PERÍODO DOS REGISTROS:{" "}
                        {formatarDataBR(grupo.dataInicio)} ATÉ{" "}
                        {formatarDataBR(grupo.dataFim)}
                      </small>
                    </div>

                    {grupo.treinamentos
                      .sort((a, b) => {
                        if (a.treinamentoAtual && !b.treinamentoAtual)
                          return -1;
                        if (!a.treinamentoAtual && b.treinamentoAtual) return 1;

                        const dataA =
                          obterValorData(a.data) ||
                          obterValorData(a.dataReferencia);
                        const dataB =
                          obterValorData(b.data) ||
                          obterValorData(b.dataReferencia);

                        if (dataA !== dataB) return dataB - dataA;

                        const nomeA = normalizarTexto(
                          a.treinamentoNome || a.tipo || "",
                        );
                        const nomeB = normalizarTexto(
                          b.treinamentoNome || b.tipo || "",
                        );
                        return nomeA.localeCompare(nomeB, "pt-BR");
                      })
                      .map((treinamento) => {
                        const temAnexo = Boolean(treinamento.anexoUrl);
                        const treinamentoAtual = Boolean(
                          treinamento.treinamentoAtual,
                        );

                        return (
                          <div className="arquivo-bloco" key={treinamento.id}>
                            <div
                              className={`arquivo ${
                                treinamentoAtual
                                  ? "arquivo-atual"
                                  : "arquivo-historico"
                              } ${!temAnexo ? "arquivo-sem-anexo" : ""}`}
                            >
                              <div className="arquivo-info">
                                <div className="icone-pdf">PDF</div>

                                <div className="arquivo-textos">
                                  <div className="linha-titulo-arquivo">
                                    <span className="arquivo-nome">
                                      {treinamento.treinamentoNome ||
                                        treinamento.tipo ||
                                        "TREINAMENTO"}
                                    </span>

                                    {treinamentoAtual ? (
                                      <span className="tag-atual">
                                        TREINAMENTO ATUAL
                                      </span>
                                    ) : (
                                      <span className="tag-historico">
                                        HISTÓRICO
                                      </span>
                                    )}
                                  </div>

                                  <small>
                                    DATA DO TREINAMENTO:{" "}
                                    {formatarDataBR(treinamento.data)}
                                  </small>

                                  <small>
                                    LANÇADO EM: OBRA {treinamento.contexto.obra}{" "}
                                    · FUNÇÃO {treinamento.contexto.funcao}
                                  </small>

                                  <small>
                                    DATA DO LANÇAMENTO:{" "}
                                    {formatarDataBR(treinamento.dataReferencia)}
                                  </small>

                                  <small>
                                    {temAnexo
                                      ? treinamento.anexoNome || "PDF ANEXADO"
                                      : "NENHUM PDF ANEXADO NESTE TREINAMENTO"}
                                  </small>
                                </div>
                              </div>

                              <div className="acoes">
                                <button
                                  type="button"
                                  onClick={() => abrirPdfOverlay(treinamento)}
                                  disabled={!temAnexo}
                                >
                                  ABRIR
                                </button>

                                <button
                                  type="button"
                                  onClick={() =>
                                    abrirNovaAba(treinamento.anexoUrl)
                                  }
                                  disabled={!temAnexo}
                                >
                                  NOVA ABA
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                ))
              ) : (
                <div className="mensagem-nuvem">
                  {filtroDocumentos || filtroVisualizacao !== "TODOS"
                    ? "NENHUM TREINAMENTO ENCONTRADO PARA ESSE FILTRO."
                    : "NENHUM TREINAMENTO ENCONTRADO PARA ESTE COLABORADOR."}
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {pdfOverlay && (
        <div className="pdf-overlay">
          <div className="pdf-overlay-content">
            <div className="pdf-overlay-topo">
              <div className="pdf-overlay-titulo">
                <strong>{pdfOverlay.nome}</strong>

                <small>
                  {pdfOverlay.treinamentoAtual
                    ? "TREINAMENTO ATUAL"
                    : "HISTÓRICO"}{" "}
                  · LANÇADO EM: OBRA {pdfOverlay.obra} · FUNÇÃO{" "}
                  {pdfOverlay.funcao}
                </small>
              </div>

              <div className="pdf-overlay-acoes">
                <button
                  type="button"
                  onClick={() => abrirNovaAba(pdfOverlay.url)}
                >
                  NOVA ABA
                </button>

                <button type="button" onClick={() => setPdfOverlay(null)}>
                  FECHAR
                </button>
              </div>
            </div>

            <iframe
              className="iframe-pdf-overlay"
              src={pdfOverlay.url}
              title={pdfOverlay.nome}
            ></iframe>
          </div>
        </div>
      )}

      <div className="btn-voltar" onClick={voltar}>
        <img src={home} alt="voltar" />
      </div>
    </div>
  );
};

export default Nuvem;
